<template>
  <article class="garage-price-list">
    <GaragePriceCategory
      v-for="category in categories"
      :category="category"
      :premium="!!premium"
      :onlineBooking="!!onlineBooking"
      :mainContext="mainContext"
      :currentFilter="currentFilter"
      @show-service-details="emits('show-service-details', $event)"
    />
  </article>
</template>

<script setup lang="ts">

import type { PriceCategoryView, PriceElementView } from '~/api/docs/app';
import { popularCategoryId } from '~/models/consts';

interface IProps {
  garagePriceListWithCategories?: PriceCategoryView[];
  limit?: boolean;
  search?: boolean;
  currentFilter?: string | null;
  mainContext?: boolean;
  sortByScore?: boolean;
  premium?: boolean;
  onlineBooking?: boolean;
}

interface IEmits {
  (name: 'set-other-reason-tab'): void;
  (name: 'show-service-details', value: PriceElementView): void;
}

// props
const props = withDefaults(defineProps<IProps>(), {
  limit: false
});

// emits
const emits = defineEmits<IEmits>();

// use 
const route = useRoute();

// methods
const nuxtLinkTo = (serviceId: string) => {
  return route.meta.layout === 'modal' ? `${route.path}/${serviceId}` : `${route.path}/services/${serviceId}`;
};

// computed
const popularPriceList: ComputedRef<PriceCategoryView> = computed(() => {
  const popularPriceList = props.garagePriceListWithCategories?.map(el => el.priceList?.filter(pl => pl.flags?.popular) || []).flat() || [];

  const popularCategory = {
    id: popularCategoryId,
    name: 'Popularne usługi',
    priceList: props.sortByScore
      ? popularPriceList.sort((a, b) => (b.score || 0) - (a.score || 0))
      : popularPriceList.sort((a, b) => {
        if ((a.name || '') < (b.name || '')) {
          return -1;
        }
        if ((a.name || '') > (b.name || '')) {
          return 1;
        }
        return 0;
      }),
    shortName: 'Popularne'
  };
  return popularCategory;
});

const contextPriceList: ComputedRef<PriceCategoryView> = computed(() => {
  const priceList = props.garagePriceListWithCategories?.map(el => el.priceList?.filter(pl => !pl.flags?.virtual && !pl.flags?.surcharge) || []).flat() || [];

  const contextCategory = {
    id: popularCategoryId,
    name: 'Popularne usługi',
    priceList: props.sortByScore
      ? priceList.sort((a, b) => (b.score || 0) - (a.score || 0))
      : priceList.sort((a, b) => {
        if ((a.name || '') < (b.name || '')) {
          return -1;
        }
        if ((a.name || '') > (b.name || '')) {
          return 1;
        }
        return 0;
      }),
    shortName: 'Popularne'
  };
  return contextCategory;
});



const categories: ComputedRef<PriceCategoryView[]> = computed(() => {
  if (props.mainContext) {
    return [contextPriceList.value];
  }

  if (props.search || props.currentFilter !== popularCategoryId) return props.garagePriceListWithCategories || [];

  return props.garagePriceListWithCategories || [];
})

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-price-list.scss');
</style>